import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: 85,
    boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    [theme.breakpoints.up('mobile')]: {
      height: 80,
      borderBottom: [1, 'solid', theme.palette.colors.border],
      boxShadow: 'none',
    },
  },
  paper: {
    padding: [0, 20],
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      maxWidth: 1420,
      margin: [0, 'auto'],
    },
  },
  leftBar: {
    display: 'flex',
    alignItems: 'center',
    width: '65%',
    [theme.breakpoints.up('mobile')]: {
      width: 'unset',
    },
  },
  rightBar: {
    display: 'flex',
    alignItems: 'center',
    width: '30%',
  },
  badge: {
    marginLeft: theme.spacing(2),
    width: 'calc(100% - 60px)',
  },
  companyLogo: {
    height: 30,
    width: 'auto',
    maxWidth: 100,
    marginLeft: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(4),
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/TopBar/useStyles.js